import React from "react";
import { AdminListTableBody } from "./AdminListTableBody";
import { AdminListTableHead } from "./AdminListTableHead";

export const AdminListTable = React.memo(function AdminListTable() {
    return (
        <table>
            <AdminListTableHead />
            <AdminListTableBody />
        </table>
    );
});